module.exports = __webpack_public_path__ + "img/404.6580d313.png";